import { WISHLIST_WIDGET_NAMES } from "@/constants/widget-names";
import { ModalManager } from "@/modal-manager";
import { WishlistsManageApproversModalWidgetDefinition } from "@apps/wishlist/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class WishlistsManageApproversModalWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly modalManager: ModalManager,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start(): void {
        this.logger.debug("WishlistsManageApproversModalWidgetInjector start", {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger?.debug(
                "WishlistsManageApproversModalWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            void (async () => {
                const WishlistsManageApproversModalWidget =
                    await this.dynamicImportManager.importDefault(
                        WishlistsManageApproversModalWidgetDefinition
                    );

                const widget = new WishlistsManageApproversModalWidget(
                    {
                        target: placeholder,
                    },
                    this.logger,
                    this.modalManager
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(
                        WISHLIST_WIDGET_NAMES.WISHLISTS_MANAGE_APPROVERS_MODAL_WIDGET
                    )
                );

                dispatchSdkEvent(
                    new WidgetInjectedSdkEvent(
                        WISHLIST_WIDGET_NAMES.WISHLISTS_MANAGE_APPROVERS_MODAL_WIDGET
                    )
                );
            })();
        });
    }
}

export default WishlistsManageApproversModalWidgetInjector;
